import { ErrorBoundary } from '@shared/components';
import { links } from '@shared/utils';
import { RouteObject } from 'react-router-dom';

import { OnboardingLayout } from '../layout';
import { AddResponsible, Data, Sended } from '../pages';

export const OnboardingRoutesPublic = (): RouteObject[] => {
  return [
    {
      element: <OnboardingLayout />,
      children: [
        {
          path: links.onboarding.main,
          element: <Data />,
        },
        {
          path: links.onboarding.companyData,
          element: <Data />,
        },
        {
          path: links.onboarding.addResponsible,
          element: <AddResponsible />,
        },
        {
          path: links.onboarding.sended,
          element: <Sended />,
        },
      ],
      errorElement: <ErrorBoundary />,
    },

    {
      path: '*',
      element: <OnboardingLayout />,
      children: [
        {
          path: '*',
          index: true,
          element: <Data />,
        },
      ],
    },
  ];
};

export const OnboardingRoutesProtected: RouteObject[] = [
  {
    element: <OnboardingLayout />,
    children: [
      {
        path: links.onboarding.main,
        element: <Data />,
      },
      {
        path: links.onboarding.companyData,
        element: <Data />,
      },
      {
        path: links.onboarding.addResponsible,
        element: <AddResponsible />,
      },
    ],
    errorElement: <ErrorBoundary />,
  },
  {
    path: '*',
    children: [
      {
        path: links.onboarding.main,
        index: true,
        element: <Data />,
      },
    ],
  },
];
